import styled from 'styled-components';
import Box from '@mui/material/Box';

export const confirmHeaderClass = 'fleets-services-confirm-header';

export const ServicesRoot = styled(Box)`
  .${confirmHeaderClass} {
    padding: 30px 20px 15px 3.75rem;
  }
`;
